import { AccordionDetailWithoutTap } from 'components';
import { FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import { Images } from '../../../../../assets/images/images.index';
import { Price, Product } from '../types/Add-subscription.types';
import './CardPrice.scss';

type ImageKeys = keyof typeof Images;

interface CardPriceProps {
  price: Price;
  product: Product;
  counts: Record<string, number>;
  handleCount: (price: Price, increment: boolean) => void;
  formatCurrency: (amount: number, currency: string) => string;
  calculatePrice: (price: Price) => number;
  getAdvantages: (product: Product, price: Price) => { name: string }[];
}

const CardPrice = ({
  price,
  product,
  counts,
  handleCount,
  formatCurrency,
  calculatePrice,
  getAdvantages,
}: CardPriceProps) => {
  return (
    <>
      <div className="item__add__property__container add-subscription__items">
        <div className="item__add__property__container__icon">
          <img
            src={Images[price.product_type_id.name.toLowerCase() as ImageKeys]}
            alt="Tipo de propiedad"
          />
          <div className="item__add__property__container__icon__detail">
            <div className="item__buy__product__tag">{price.alias_name}</div>
            <div className="item_price">
              {formatCurrency(calculatePrice(price), price.currency.acronym)}{' '}
              {price.periocity_id.name.toUpperCase()}
            </div>
            <div className="item_type">
              {price.product_type_id.name.toLowerCase() !== 'hogar' &&
                typeof price.max_property_age === 'number' &&
                typeof price.min_property_age === 'number' &&
                `Modelos de ${
                  new Date().getFullYear() - price.max_property_age
                } a ${
                  price.min_property_age === 0
                    ? new Date().getFullYear()
                    : new Date().getFullYear() - price.min_property_age
                }
                    `}
            </div>
          </div>
        </div>
        <div className="card-actions">
          <button
            className="icon-button"
            onClick={() => handleCount(price, false)}
            disabled={!counts[price.id]}
          >
            <FaMinusCircle />
          </button>
          <span className="count">{counts[price.id] || 0}</span>
          <button
            className="icon-button"
            onClick={() => handleCount(price, true)}
            disabled={(counts[price.id] || 0) >= price.max_count}
          >
            <FaPlusCircle />
          </button>
        </div>
      </div>
      <AccordionDetailWithoutTap
        title="Ver detalles del producto"
        titleTermsAndConditions={'Ver contrato'}
        data={getAdvantages(product, price)}
        url_policies={product.url_policies}
      />
    </>
  );
};

export default CardPrice;
